/* =========================================================
   Mega Menu Soar (mms) — JS
   Desktop: painéis do mega menu (mouse, toque e teclado).
   Celular: menu lateral com níveis (push navigation).
   Também: some com o aviso do topo ao rolar e atualiza o número da sacola.

   Reescrito em 09/10/26 mantendo as mesmas classes e o mesmo visual. Mudanças:
   - toque em tablet/desktop sem mouse: 1º toque abre o painel, 2º toque segue o link
   - teclado: Enter/Espaço abre, Esc fecha e devolve o foco, Tab para fora fecha
   - menu do celular: foco preso dentro dele, Esc volta um nível, fecha sozinho ao virar desktop
   - editor de tema: reinicia sem duplicar eventos quando a seção do header é recarregada
   ========================================================= */
(function () {
	'use strict';

	var DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');
	var NO_HOVER_MQ = window.matchMedia('(hover: none)');
	var CLOSE_DELAY = 100;
	var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

	var controller = null;

	function init() {
		if (controller) controller.abort();
		var root = document.querySelector('.header--mms');
		if (!root) return;
		controller = new AbortController();
		var signal = controller.signal;
		var on = function (el, type, fn, opts) {
			if (!el) return;
			var o = Object.assign({ signal: signal }, opts || {});
			el.addEventListener(type, fn, o);
		};

		initMega(root, on);
		initDrawer(root, on);
		initAnnouncement(on);
		initCartCount(root, on);
	}

	/* ---------- Desktop: mega menu ---------- */

	function initMega(root, on) {
		var headerEl = root.querySelector('.mms-header');
		var trigger = (headerEl && headerEl.dataset.mmsTrigger) || 'hover';
		var overlayEl = document.querySelector('[data-mms-overlay]');
		var items = Array.prototype.slice.call(root.querySelectorAll('.mms-nav__item--has-mega'));
		var openItem = null;
		var closeTimer = null;
		var lastPointer = 'mouse';

		function parts(item) {
			return {
				link: item.querySelector('[data-mms-mega-trigger]'),
				mega: item.querySelector('.mms-mega')
			};
		}

		function setOpen(item, open) {
			var p = parts(item);
			item.classList.toggle('mms-nav__item--open', open);
			if (p.link) p.link.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (p.mega) {
				p.mega.setAttribute('aria-hidden', open ? 'false' : 'true');
				p.mega.classList.toggle('mms-mega--open', open);
			}
		}

		function openMega(item) {
			clearTimeout(closeTimer);
			if (openItem === item) return;
			if (openItem) setOpen(openItem, false);
			setOpen(item, true);
			openItem = item;
			root.classList.add('header--mms-mega-open');
			if (overlayEl) overlayEl.classList.add('is-visible');
		}

		function closeMega(immediate) {
			clearTimeout(closeTimer);
			var doClose = function () {
				if (!openItem) return;
				setOpen(openItem, false);
				openItem = null;
				if (!plainHover) root.classList.remove('header--mms-mega-open');
				if (overlayEl) overlayEl.classList.remove('is-visible');
			};
			if (immediate) doClose();
			else closeTimer = setTimeout(doClose, CLOSE_DELAY);
		}

		function focusFirst(mega) {
			var first = mega ? mega.querySelector(FOCUSABLE) : null;
			if (first) first.focus();
		}

		function isTouchLike() {
			return lastPointer === 'touch' || lastPointer === 'pen' || NO_HOVER_MQ.matches;
		}

		// Links simples do topo (Membership): mesmo efeito dos itens com painel, sem painel.
		// Só com mouse; no toque o link segue direto.
		var plainHover = null;
		root.querySelectorAll('.mms-header-link').forEach(function (plain) {
			on(plain, 'pointerenter', function (e) {
				if (e.pointerType !== 'mouse') return;
				plainHover = plain;
				if (openItem) closeMega(true);
				plain.classList.add('mms-header-link--pill');
				root.classList.add('header--mms-mega-open');
			});
			on(plain, 'pointerleave', function () {
				if (plainHover !== plain) return;
				plainHover = null;
				plain.classList.remove('mms-header-link--pill');
				if (!openItem) root.classList.remove('header--mms-mega-open');
			});
		});

		items.forEach(function (item) {
			var p = parts(item);

			on(item, 'pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });

			if (trigger === 'hover') {
				on(item, 'pointerenter', function (e) {
					if (e.pointerType === 'mouse') openMega(item);
				});
				on(item, 'pointerleave', function (e) {
					if (e.pointerType === 'mouse') closeMega(false);
				});
			}

			if (p.link) {
				var isLink = p.link.tagName === 'A';

				on(p.link, 'click', function (e) {
					var isOpen = openItem === item;
					var viaKeyboard = e.detail === 0;
					if (!isLink) {
						// Botão (Explorar): com mouse no modo hover o painel já abriu ao passar o mouse,
						// então o clique não fecha; no toque, no teclado ou no modo clique, alterna.
						e.preventDefault();
						if (!isOpen) {
							openMega(item);
							if (viaKeyboard) focusFirst(p.mega);
						} else if (viaKeyboard || trigger === 'click' || isTouchLike()) {
							closeMega(true);
						}
						return;
					}
					// Link: no modo clique ou no toque, o 1º clique abre e o 2º segue o link
					if (!isOpen && (trigger === 'click' || isTouchLike())) {
						e.preventDefault();
						openMega(item);
					}
				});

				on(p.link, 'keydown', function (e) {
					var open = openItem === item;
					if (isLink && (e.key === 'Enter' || e.key === ' ') && !open) {
						e.preventDefault();
						openMega(item);
						focusFirst(p.mega);
					} else if (e.key === 'ArrowDown') {
						e.preventDefault();
						openMega(item);
						focusFirst(p.mega);
					}
				});
			}

			// Tab para fora do item fecha o painel
			on(item, 'focusout', function (e) {
				if (openItem === item && e.relatedTarget && !item.contains(e.relatedTarget)) closeMega(true);
			});
		});

		on(document, 'click', function (e) {
			if (openItem && !openItem.contains(e.target)) closeMega(true);
		});

		on(document, 'keydown', function (e) {
			if (e.key !== 'Escape' || !openItem) return;
			var link = parts(openItem).link;
			var hadFocus = openItem.contains(document.activeElement);
			closeMega(true);
			if (hadFocus && link) link.focus();
		});

		if (overlayEl) on(overlayEl, 'click', function () { closeMega(true); });

		// Ao virar celular, nenhum painel fica aberto
		on(DESKTOP_MQ, 'change', function (e) { if (!e.matches) closeMega(true); });

		// Editor de tema: selecionar um bloco abre o painel dele
		if (window.Shopify && window.Shopify.designMode) {
			on(document, 'shopify:block:select', function (e) {
				var mega = e.target.closest && e.target.closest('.mms-mega');
				var item = mega && mega.closest('.mms-nav__item');
				if (item) openMega(item);
			});
			on(document, 'shopify:block:deselect', function (e) {
				var mega = e.target.closest && e.target.closest('.mms-mega');
				if (mega) closeMega(true);
			});
		}
	}

	/* ---------- Celular: menu lateral ---------- */

	function initDrawer(root, on) {
		var drawer = document.getElementById('mms-drawer');
		var burger = root.querySelector('.mms-burger');
		if (!drawer || !burger) return;

		var levelsWrap = drawer.querySelector('[data-mms-drawer-levels]');
		var backBtn = drawer.querySelector('[data-mms-drawer-back]');
		var backLabel = drawer.querySelector('[data-mms-drawer-back-label]');
		var closeBtn = drawer.querySelector('.mms-drawer__close');
		var panel = drawer.querySelector('.mms-drawer__panel');
		var stack = ['0'];
		var usingKeyboard = false;
		on(document, 'keydown', function () { usingKeyboard = true; }, { capture: true });
		on(document, 'pointerdown', function () { usingKeyboard = false; }, { capture: true });

		function levelEl(key) {
			return levelsWrap ? levelsWrap.querySelector('[data-level="' + CSS.escape(key) + '"]') : null;
		}

		function showLevel(key) {
			var target = levelEl(key);
			if (!target) return;
			levelsWrap.querySelectorAll('.mms-drawer__level').forEach(function (lv) {
				lv.classList.remove('mms-drawer__level--active', 'mms-drawer__level--prev');
			});
			target.classList.add('mms-drawer__level--active');
			target.scrollTop = 0;
			var atRoot = key === '0';
			if (backBtn) backBtn.hidden = atRoot;
			if (closeBtn) closeBtn.hidden = !atRoot;
			if (!atRoot && backLabel) backLabel.textContent = target.dataset.title || '';
		}

		function pushLevel(key) {
			if (!levelEl(key)) return;
			stack.push(key);
			showLevel(key);
			if (usingKeyboard && backBtn) backBtn.focus({ preventScroll: true });
		}

		function popLevel() {
			if (stack.length <= 1) return false;
			var from = stack.pop();
			showLevel(stack[stack.length - 1]);
			var opener = levelsWrap.querySelector('[data-mms-drawer-open-level="' + CSS.escape(from) + '"]');
			if (usingKeyboard && opener) opener.focus({ preventScroll: true });
			return true;
		}

		function setAnnouncementHidden(hidden) {
			// Aviso flutuante (seção announcement-bar-dopa) e aviso interno do header
			var ann = document.querySelector('[data-ai-announcement-floating]');
			var sec = ann ? ann.closest('.shopify-section') : null;
			document.body.classList.toggle('ai-announcement-hidden', hidden);
			if (sec) sec.classList.toggle('is-hidden-on-scroll', hidden);
			var header = document.querySelector('.mms-header');
			if (header) header.classList.toggle('mms-ann-hidden', hidden);
		}

		function isOpen() { return drawer.classList.contains('is-open'); }

		function openDrawer() {
			drawer.classList.add('is-open');
			drawer.setAttribute('aria-hidden', 'false');
			burger.setAttribute('aria-expanded', 'true');
			document.body.classList.add('mms-no-scroll', 'mms-drawer-open');
			setAnnouncementHidden(true);
			stack = ['0'];
			showLevel('0');
			// Foco no painel (leitores de tela anunciam o menu); com teclado, no 1º item
			var first = levelEl('0') && levelEl('0').querySelector(FOCUSABLE);
			if (usingKeyboard && first) first.focus({ preventScroll: true });
			else if (panel) panel.focus({ preventScroll: true });
		}

		function closeDrawer() {
			if (!isOpen()) return;
			drawer.classList.remove('is-open');
			drawer.setAttribute('aria-hidden', 'true');
			burger.setAttribute('aria-expanded', 'false');
			document.body.classList.remove('mms-no-scroll', 'mms-drawer-open');
			// O aviso só volta se a página estiver no topo
			if (window.scrollY === 0) setAnnouncementHidden(false);
			if (drawer.contains(document.activeElement)) burger.focus({ preventScroll: true });
		}

		on(burger, 'click', function () { if (isOpen()) closeDrawer(); else openDrawer(); });
		drawer.querySelectorAll('[data-mms-drawer-close]').forEach(function (btn) { on(btn, 'click', closeDrawer); });
		on(backBtn, 'click', popLevel);

		on(levelsWrap, 'click', function (e) {
			var opener = e.target.closest('[data-mms-drawer-open-level]');
			if (!opener) return;
			e.preventDefault();
			pushLevel(opener.dataset.mmsDrawerOpenLevel);
		});

		on(document, 'keydown', function (e) {
			if (!isOpen()) return;
			if (e.key === 'Escape') {
				if (!popLevel()) closeDrawer();
				return;
			}
			if (e.key === 'Tab' && panel) {
				// Mantém o foco dentro do menu aberto (só elementos visíveis)
				var nodes = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (n) {
					return n.offsetParent !== null && getComputedStyle(n).visibility !== 'hidden';
				});
				if (!nodes.length) return;
				var first = nodes[0], last = nodes[nodes.length - 1];
				if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
				else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
			}
		});

		// Virou desktop com o menu aberto: fecha e libera a rolagem
		on(DESKTOP_MQ, 'change', function (e) { if (e.matches) closeDrawer(); });

		// Arrastar para o lado fecha
		if (panel) {
			var sx = 0, sy = 0;
			on(panel, 'touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
			on(panel, 'touchend', function (e) {
				var dx = e.changedTouches[0].clientX - sx;
				var dy = e.changedTouches[0].clientY - sy;
				if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy)) return;
				// No celular o painel abre pela direita (CSS); no desktop respeita data-side
				var side = DESKTOP_MQ.matches ? (drawer.dataset.side || 'left') : 'right';
				if ((side === 'left' && dx < 0) || (side === 'right' && dx > 0)) closeDrawer();
			}, { passive: true });
		}
	}

	/* ---------- Aviso do topo: some ao rolar, volta no topo ---------- */

	function initAnnouncement(on) {
		var header = document.querySelector('.mms-header');
		if (!header || !document.querySelector('.mms-ann')) return;
		var ticking = false;
		function update() {
			ticking = false;
			if (document.body.classList.contains('mms-drawer-open')) return;
			header.classList.toggle('mms-ann-hidden', window.scrollY > 0);
		}
		on(window, 'scroll', function () {
			if (ticking) return;
			ticking = true;
			window.requestAnimationFrame(update);
		}, { passive: true });
		update();
	}

	/* ---------- Número da sacola ---------- */

	function initCartCount(root, on) {
		var countEl = root.querySelector('[data-cart-count]');
		if (!countEl) return;
		var pending = null;
		function refresh() {
			clearTimeout(pending);
			pending = setTimeout(function () {
				var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
				fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (typeof data.item_count !== 'number') return;
						countEl.textContent = data.item_count;
						countEl.setAttribute('data-count', data.item_count);
					})
					.catch(function () {});
			}, 50);
		}
		['cart:updated', 'cart:refresh', 'cart:item-added'].forEach(function (ev) { on(document, ev, refresh); });
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
	else init();

	// Editor de tema: a seção do header é trocada inteira — reinicia sem duplicar eventos
	if (window.Shopify && window.Shopify.designMode) {
		document.addEventListener('shopify:section:load', function (e) {
			if (e.target && e.target.querySelector && e.target.querySelector('.header--mms')) init();
		});
	}
})();
